angular.module('impactx.compilationarticle').controller('CompilationArticleViewCtrl', [
    'dataGen',
    '$routeParams',
    'AddToBasketService',
    '$redirect',
    'TranslationService',
    'ToolbarService',
    CompilationArticleViewController]);

function CompilationArticleViewController(dataGen, $routeParams, AddToBasketService, $redirect, TranslationService, ToolbarService) {
    var self = this;

    dataGen.getData(self, {proId: $routeParams.proId}, "/compilationarticle/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        ToolbarService.setButtons([]);
    }

    self.addToBasket = function (event) {
        AddToBasketService.addToBasket(self.data, 1, TranslationService.get('openBasket'), false, event);
    };

    self.redirectToProduct = function (row) {
        $redirect.redirectTo(null, self.getProductLink(row.proId));
    };

    self.getProductLink = function (proId) {
        return "/product/" + proId;
    };
}